import IconComponent from "components/IconComponent"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext } from "react"
import { Button } from "@nextui-org/react"
import { useDictionary } from "@adamlip/okeoke.client"
import { MainContext } from "contexts/MainContext"
function OrderHeader() {
  const { appParams } = useContext(AppParamsContext)
  const {
    setShowSearchModal,
    setShowAllCategoriesModal,
  } = useContext(MainContext)
  const { getValue } = useDictionary()
  if (!appParams?.items?.showAllCategoryButton && !appParams?.items?.showSearch)
    return null
  return (
    <div className="px-[22px] flex flex-row items-center justify-between md:justify-start gap-4 max-w-[600px]">
      {appParams?.items?.showAllCategoryButton && (
        <Button onPress={() => setShowAllCategoriesModal(true)} size="sm">
          <div className="w-6 h-6">
            <IconComponent iconCode={"list"} className={"current"} />
          </div>
          {getValue("app_v2_order_allCategoriesButtonLabel")}
        </Button>
      )}
      {appParams?.items?.showSearch && (
        <Button onPress={() => setShowSearchModal(true)} size="sm">
          <div className="w-6 h-6">
            <IconComponent iconCode={"search"} className={"current"} />
          </div>
          {getValue("app_v2_order_searchButtonLabel")}
        </Button>
      )}
    </div>
  )
}

export default OrderHeader
